export default {
  'pages.rental.table.title': '出租资金流水历史记录',
  'pages.rental.table.columns.propRentalId': '出租记录ID',
  'pages.rental.table.columns.parkingStructureName': '房源名称',
  'pages.rental.table.columns.recordType': '流水类型',
  'pages.rental.table.columns.amount': '金额',
  'pages.rental.table.columns.paymentDate': '付款日期',
  'pages.rental.table.columns.paidUntilMonth': '账期',
  'pages.rental.table.columns.remarks': '备注',
  'pages.rental.table.columns.operations': '操作',

  'pages.rental.recordType.income': '收入',
  'pages.rental.recordType.expense': '支出',

  'pages.rental.actions.add': '出租房收支登记',
  'pages.rental.modal.createTitle': '新增出租房收支登记',
  'pages.rental.modal.editTitle': '编辑出租房收支登记',
  'pages.rental.actions.view': '查看',
  'pages.rental.actions.edit': '编辑',
  'pages.rental.actions.delete': '删除',
  'pages.rental.actions.batchDelete': '批量删除',

  'pages.rental.form.createTitle': '新建流水记录',
  'pages.rental.form.editTitle': '编辑流水记录',
  'pages.rental.form.propRentalId': '出租记录ID',
  'pages.rental.form.propRentalIdRequired': '请输入出租记录ID',
  'pages.rental.form.propRentalIdPlaceholder': '请输入出租记录ID',
  'pages.rental.form.recordType': '流水类型',
  'pages.rental.form.recordTypeRequired': '请选择流水类型',
  'pages.rental.form.recordTypePlaceholder': '请选择流水类型',
  'pages.rental.form.amount': '金额',
  'pages.rental.form.amountRequired': '请输入金额',
  'pages.rental.form.amountPlaceholder': '请输入金额',
  'pages.rental.form.paymentDate': '付款日期',
  'pages.rental.form.paymentDateRequired': '请选择付款日期',
  'pages.rental.form.paymentDatePlaceholder': '请选择付款日期',
  'pages.rental.form.paidUntilMonth': '账期',
  'pages.rental.form.paidUntilMonthPlaceholder': '例如：2025-06',
  'pages.rental.form.remarks': '备注',

  'pages.rental.detail.title': '流水记录详情',
  'pages.rental.detail.propRentalId': '出租记录ID',
  'pages.rental.detail.recordType': '流水类型',
  'pages.rental.detail.amount': '金额',
  'pages.rental.detail.paymentDate': '付款日期',
  'pages.rental.detail.paidUntilMonth': '账期',
  'pages.rental.detail.remarks': '备注',
  'pages.rental.detail.createdTime': '创建时间',

  'pages.rental.confirm.deleteTitle': '确认删除',
  'pages.rental.confirm.deleteContent': '确定要删除这条流水记录吗？',
  'pages.rental.confirm.batchDeleteTitle': '确认批量删除',
  'pages.rental.confirm.batchDeleteContent':
    '确定要删除选中的 {count} 条记录吗？',

  'pages.rental.message.createSuccess': '创建成功',
  'pages.rental.message.createFailed': '创建失败',
  'pages.rental.message.updateSuccess': '更新成功',
  'pages.rental.message.updateFailed': '更新失败',
  'pages.rental.message.deleteSuccess': '删除成功',
  'pages.rental.message.deleteFailed': '删除失败',
  'pages.rental.message.batchDeleteSuccess': '批量删除成功',
  'pages.rental.message.batchDeleteFailed': '批量删除失败',
  'pages.rental.message.loadFailed': '加载记录失败',
  'pages.rental.message.selectRecords': '请先选择要删除的记录',
};
